/* tslint:disable */
/* eslint-disable */
/**
 * predictonco-backend API
 * predictonco-backend API
 *
 * The version of the OpenAPI document: 1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StabilityPrediction
 */
export interface StabilityPrediction {
    /**
     * 
     * @type {number}
     * @memberof StabilityPrediction
     */
    value: number;
    /**
     * 
     * @type {number}
     * @memberof StabilityPrediction
     */
    threshold: number;
}

/**
 * Check if a given object implements the StabilityPrediction interface.
 */
export function instanceOfStabilityPrediction(value: object): value is StabilityPrediction {
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('threshold' in value) || value['threshold'] === undefined) return false;
    return true;
}

export function StabilityPredictionFromJSON(json: any): StabilityPrediction {
    return StabilityPredictionFromJSONTyped(json, false);
}

export function StabilityPredictionFromJSONTyped(json: any, ignoreDiscriminator: boolean): StabilityPrediction {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
        'threshold': json['threshold'],
    };
}

export function StabilityPredictionToJSON(json: any): StabilityPrediction {
    return StabilityPredictionToJSONTyped(json, false);
}

export function StabilityPredictionToJSONTyped(value?: StabilityPrediction | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
        'threshold': value['threshold'],
    };
}

